import { render, staticRenderFns } from "./AdManagerBannersEditDialog.vue?vue&type=template&id=78b6118c"
import script from "./AdManagerBannersEditDialog.js?vue&type=script&lang=js&external"
export * from "./AdManagerBannersEditDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports